import { IoIosArrowBack } from 'react-icons/io';
import * as C from '../../../../../ui/common/CommonStyles';
import { useNavigate, useParams } from 'react-router-dom';
import { handleChangeLocaleTime } from '../../../../../../shared/utils/time';
import { Button, Badge, Flex, Title, Text, Divider, Group } from '@mantine/core';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getLanguage, getNoticeType, getSolution } from '../../../../../../shared/constants/commonCode';
import { IconPencil, IconTrash } from '@tabler/icons-react';
import Swal from 'sweetalert2';
import { handleError } from '../../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { Viewer } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { operationApis } from '../../../../../../shared/apis/operation/apis';

export default function NoticeDetail() {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: noticeDetails } = useQuery(['getNoticeDetail', id], () => operationApis.getNoticeDetail(id as string), {
    enabled: !!id,
    refetchOnMount: true,
    select: (data) => data.data.result[0],
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });

  const { mutate: deleteNotice } = useMutation((id: string) => operationApis.deleteNotice(id), {
    onSuccess: () => {
      navigate('/admin/edgecross/notice');
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });

  const onClickDeleteNotice = (id: string) => {
    Swal.fire({
      title: '공지사항을 삭제하시겠습니까?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        deleteNotice(id);
      }
    });
  };

  return (
    <div>
      <C.TitleBox>
        <div className="title">공지사항</div>
      </C.TitleBox>
      <C.ListBox>
        <Flex justify="space-between">
          <Button variant="default" onClick={() => navigate('/admin/edgecross/notice')} leftSection={<IoIosArrowBack />}>
            목록으로
          </Button>
          <Group gap={4}>
            <Button
              leftSection={<IconPencil />}
              color="gray"
              variant="subtle"
              onClick={() => navigate(`/admin/edgecross/notice/write?id=${id}`)}
            >
              수정
            </Button>
            <Button leftSection={<IconTrash />} color="red" variant="subtle" onClick={() => onClickDeleteNotice(id as string)}>
              삭제
            </Button>
          </Group>
        </Flex>
        <C.ListBox>
          <Flex justify="space-between">
            <div>
              <Text c="gray" size="sm">
                {`${getSolution(noticeDetails.solutionCd as keyof typeof getSolution)} | ${getLanguage(
                  noticeDetails.languageCd as keyof typeof getLanguage,
                )}`}
              </Text>
              <Title order={2} my={4}>{`[${getNoticeType(
                noticeDetails.noticeCd as keyof typeof getNoticeType,
              )}] ${noticeDetails.title}`}</Title>
              <Text c="gray" size="sm">
                {`${noticeDetails.modUserName}  |  ${handleChangeLocaleTime(noticeDetails.modDate, {
                  includeTime: true,
                })} `}
              </Text>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Badge size="lg" variant="light">
                대표글
              </Badge>
            </div>
          </Flex>
          <Divider my="xs" />
          <Viewer initialValue={noticeDetails.content} />
        </C.ListBox>
      </C.ListBox>
    </div>
  );
}
